// Chart grammar (pure): "normal = grey band, only escapees get colour + label." An escapee is a
// point outside its expected band [lo, hi]. These helpers are unit-tested without a DOM/canvas.

export interface BandPoint {
  t: number; // x (unix seconds)
  v: number | null; // measured value (null = no data; never 0 for missing)
  lo: number; // expected band low
  hi: number; // expected band high
}

export interface Escapee {
  index: number;
  t: number;
  v: number;
  direction: "above" | "below";
}

export function findEscapees(points: readonly BandPoint[]): Escapee[] {
  const out: Escapee[] = [];
  points.forEach((p, index) => {
    if (p.v === null) return; // missing is not an escapee — it's absent
    if (p.v > p.hi) out.push({ index, t: p.t, v: p.v, direction: "above" });
    else if (p.v < p.lo) out.push({ index, t: p.t, v: p.v, direction: "below" });
  });
  return out;
}

/** One-line summary for the chart's accessible caption (figures are stated, never implied). */
export function escapeeSummary(points: readonly BandPoint[], unit: string): string {
  const escapees = findEscapees(points);
  const measured = points.filter((p) => p.v !== null).length;
  if (measured === 0) return "No data in range.";
  if (escapees.length === 0) return `${measured} points in range, all within the expected band (${unit}).`;
  return `${measured} points in range; ${escapees.length} outside the expected band (${unit}).`;
}
